module.exports = __webpack_public_path__ + "static/media/358.38e1a578.png";